// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notifications  .product {\r\n   background-color: #F5F5F5;\r\n}", "",{"version":3,"sources":["webpack://./App/Components/Notifications/notifications.css"],"names":[],"mappings":"AAAA;GACG,yBAAyB;AAC5B","sourcesContent":[".notifications  .product {\r\n   background-color: #F5F5F5;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
